import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app/shared/services/api.service';
import { APIRequest } from '@app/shared/services/req-res.types';
import { UtilService } from '@app/shared/services/util.service';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/shared/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCallService {
  languageDetectionUrl: string;

constructor(private http:HttpClient,
  private api: ApiService,
  private util:UtilService,
  private config: ConfigService,) {
    this.languageDetectionUrl = this.config.languageDetectionURL;
  }

  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  /*---------------------------------------------------------------------Language related services-----------------------------------------------*/
public getAllKeys(): Observable<any> {
  return this.api.get('/api-keys');
}

public getLogsById(id: string): Observable<any> {
  return this.api.get(`/api-keys/logs/${id}`);
}

public createKey(data: any): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      ...data,
    },
  }
  return this.api.post('/api-keys', postData);
}

public updateKeyStatus(data: any): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      ...data,
    },
  }
  return this.api.post('/api-keys/toggleActive', postData);
}

public LanguageListData(quesid){
  return  this.api.get(
    `${URL.CONTENT.LANGUAGE_LIST}/${quesid}`, {});
}

public getLanguage(){
  return  this.api.get(
    `${URL.CONTENT.LANGUAGE}`, {});
}

public getLanguageDetectToken(key){
  const headers = {
    'Content-Type': 'application/json', 
    // 'x-access-token': ''
  };
  const language_detection_api_key = this.config.languageDetectionApiKey;
  const body = {
    api_key : language_detection_api_key
  }
  return this.http.post(
    `${this.languageDetectionUrl}/get_token` , body, {headers}
  );
}

public detectQuestionLanguage(text: string , token:string) {

  const headers = {
    'Content-Type': 'application/json',
    'x-access-token': token || ''
  };

  const body = {
    input_type: 'text',
    text: text
  };

  return this.http.post(`${this.languageDetectionUrl}/detect`, body, { headers });
}



public saveLanguage(payload){
    return this.api.post(`${URL.CONTENT.LANGUAGE_LIST}`, payload);
}

public deleteLanguage(id:string){
  return this.api.delete(URL.CONTENT.LANGUAGE_LIST,id);
}

public downloadPublishedQuestionPaper(id: any) {    
  return this.api.get(`${URL.CONTENT.GET_PUBLISHED_QUESTION_PAPER}/${id}`);
}

/*--------------------------------------------------------Test related services--------------------------------------------------------*/
public QuestionPaperListData(data){
  const postData: APIRequest = {
       
    requestBody: {
      ...data,
      orgId: parseInt(this.orgID, 10),
    }
  };
  
  return this.api.post(URL.CONTENT.GET_QUESTION_PAPER_LIST, postData );
}
deleteQuestionPaper(id:any){
  return this.api.delete(URL.CONTENT.DELETE_QUESTION_PAPER, id)
}

public UpdateQuestionPaperStatus(data){
  const postData: APIRequest = {
       
    requestBody: {
      ...data,
    }
  };
  
  return this.api.post(URL.CONTENT.UPDATE_QUESTION_PAPER_STATUS, postData );
}
public uploadtoS3(data:any,fileName:string,fileType:string){
  const file={data:data ,fileName:fileName,fileType:fileType};
  const postData: APIRequest = {
    requestBody: {
      file:data,
      folder:'assessment_plan',
    }
  };
  console.log(data,"sad");
  return this.api.post(URL.ADMIN.UPLOAD_FILES, postData );
}

public revertQuestionPaperVersion(payload){
  const postData: APIRequest = {
    requestBody: {
      ...payload,
    }
  };
  return this.api.post(URL.CONTENT.REVERT_QUESTION_PAPER_VERSION, postData);
}

public compareQuestionPaperVersions(payload){
  const postData: APIRequest = {
    requestBody: {
      ...payload,
    }
  };
  return this.api.post(URL.CONTENT.COMPARE_QUESTION_PAPER_VERSIONS, postData);
}

public getQuestionPaperVersion(payload){
  const postData: APIRequest = {
       
    requestBody: {
      ...payload,
      orgId: parseInt(this.orgID, 10),
    }
  };
  return this.api.post(`${URL.CONTENT.GET_QUESTION_PAPER_VERSION_LIST}`, postData);
}

public addEditQuestionPaperVersion(payload){
  const postData: APIRequest = {   
    requestBody: {
      ...payload,
      orgId: parseInt(this.orgID, 10),
    }
  };
  return this.api.post(`${URL.CONTENT.ADD_EDIT_QUESTION_PAPER_VERSION}`, postData);
}

public appendQuestionPaperVersions(payload){
  const postData: APIRequest = {   
    requestBody: {
      ...payload,
      orgId: parseInt(this.orgID, 10),
    }
  };
  return this.api.post('/question-paper/append-versions', postData);
}

public deleteQuestionPaperVersion(payload){
  const postData: APIRequest = {   
    requestBody: {
      ...payload,
    }
  };
 return this.api.post(`${URL.CONTENT.DELETE_QUESTION_PAPER_VERSION}`,postData );
}

  public updateStatusQuestionPaperVersion(payload){
    const postData: APIRequest = {   
      requestBody: {
        ...payload,
      }
    };
    return this.api.post(`${URL.CONTENT.UPDATE_STATUS_QUESTION_PAPER_VERSION}`, postData);
  }
  /*----------------------------------------------------CANDIDATE RELATED SERVICES-------------------*/
  public updateCandidateStatus(payload) {
   
    const postData: APIRequest = {   
      requestBody: payload
    };
  
    // Send the updated object to the backend
    return this.api.put(`${URL.OPERATIONS.CANDIDATES}/${payload.id}`, postData);
  }
  public getadmitcard(payload) {
    console.log('Incoming payload:', payload);
    console.log('Parsed orgID:', parseInt(this.orgID, 10));
  
    const postData: APIRequest = {
      requestBody: {
        ...payload,
        orgId: parseInt(this.orgID, 10),
      }
    };
  
    console.log('Final postData:', postData);
    console.log('API Endpoint:', `${URL.OPERATIONS.CANDIDATES}`);
  
    return this.api.post(`${URL.OPERATIONS.CANDIDATE_ADMIT_CARD}`, postData);
  }

  public getCandidateById(candidateId: string): Observable<any> {
    return this.api.get(`${URL.OPERATIONS.CANDIDATES}/${candidateId}`);
  }
  public sendAdmitCardEmail(payload: any): Observable<any> {
    const postData: APIRequest = {
      requestBody: payload
    };
    return this.api.post(`${URL.OPERATIONS.SEND_ADMIT_CARD_EMAIL}`, postData);
  }

  /*-----------------------Global Search--------------------------------*/

  searchQuery(query: string): Observable<any> {
    const body = { query : query };
    return this.api.get(`/search` , body);
  }

}